export default "__VITE_ASSET__d6voYaeh__"